import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'

import { AJSubHeader } from 'components/sections/dashboard'
import { DashboardGrid as Grid } from 'components/layout'
import {
  JourneyOverviewModal,
  CompleteParticipantEventJourneyModal,
  AssessorAjEventApprovalModal,
  AlreadyAssessedModal,
  LeaderApprovalModal,
  AssessorMissingModal
} from 'components/modals'
import { modal } from 'helpers/decorators'
import { apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import getAJProgressArray from 'helpers/dashboard/getAJProgressArray'
import { selectAJ } from 'helpers/selectors'
import {
  AJ_EVENT_CATEGORIES,
  ACTIVITY_SECTIONS,
  ACTIVITY_STATES, CONFIGURATION_KEYS
} from 'constants/enums'
import MODALS from 'constants/layout/modals'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { renderRoutes } from 'react-router-config'
import config from 'config'
import { isAssessorManagementEnabledForActivity } from '../../../helpers/assessorHelper'

const colorClass = getActivityClassName(
  ACTIVITY_SECTIONS.adventurous_journey.id
)

@modal.trigger()
@apiConfiguration()
@apiDashboard.apiAdventurousJourney({
  refreshKey: 'params.awardId',
  loaders: ['approval'],
  loadPTSignoffAction: true
})
@connect((state, props) => ({
  event: selectAJ(props.aJValues, props.params.categoryId, props.params.id)
}))
class AdventurousJourney extends Component {
  static propTypes = {
    route: PropTypes.any,
    params: PropTypes.object.isRequired,
    aJValues: PropTypes.object,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    event: PropTypes.object,
    approvalStatus: PropTypes.object,
    onGetAJDetail: PropTypes.func,
    onAssessorRequestPE: PropTypes.func,
    onAssessorLeaderPE: PropTypes.func,
    onSendAlreadyAssessed: PropTypes.func,
    onGetConfigurationValue: PropTypes.func.isRequired
  }

  componentDidMount = async() => {
    const orgId = get(this.props, 'event.ajEvent.organization.id')

    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorManagementEnabled.id, orgId, true)
    this.checkAssessment()
  }

  componentDidUpdate(prevProps) {
    if (get(prevProps, 'params.id') !== get(this.props, 'params.id')) {
      this.checkAssessment()
    }
  }

  checkAssessment = () => {
    const { event } = this.props

    if (
      get(event, 'state.value') === ACTIVITY_STATES.assessment.id &&
      get(event, 'isAssessmentPositive') === true
    ) {
      this.openLeaderRequest()
    }
  }

  handleOpenAlreadyAssessed = () => {
    this.props.onClose()
    setTimeout(() => {
      this.props.onOpen(
        `${MODALS.ALREADY_ASSESSED_PE}_${get(this.props.event, 'id')}`
      )
    }, 500)
  }

  handleClickReport = e => {
    e.stopPropagation()
    const { event } = this.props
    const isAssessmentPositive = get(event, 'isAssessmentPositive')

    if (isAssessmentPositive) {
      this.openLeaderRequest()
    } else {
      this.props.onGetAJDetail(get(event, 'id')).then(({ body }) => {
        // check if journey has Supervisor or Assessor
        const hasSupervisor =
          get(event, 'ajEvent.ajEventCategory.value') ===
          AJ_EVENT_CATEGORIES.practice.id

        let canContinue = false

        if (hasSupervisor) {
          canContinue = Boolean(get(body, 'ajEvent.supervisorEmail'))
        } else {
          canContinue = Boolean(get(body, 'ajEvent.assessorEmail'))
        }

        if (canContinue) {
          this.props.onOpen(
            `${MODALS.COMPLETE_PE}_${get(this.props.event, 'id')}`
          )
        } else {
          this.props.onOpen(
            `${MODALS.ASSESSOR_MISSING_INFO}_${get(this.props.event, 'id')}`,
            hasSupervisor
          )
        }
      })
    }
  }

  openLeaderRequest = () =>
    this.props.onOpen(
      `${MODALS.LEADER_REQUEST_PE}_${get(this.props.event, 'id')}`
    )

  handleAssessorRequest = (fields, options) =>
    this.props.onAssessorRequestPE(get(this.props.event, 'id'), fields, options)

  handleLeaderRequest = (fields, options) =>
    this.props.onAssessorLeaderPE(get(this.props.event, 'id'), fields, options)

  handleSendAlreadyAssessed = (fields, options) =>
    this.props.onSendAlreadyAssessed(
      get(this.props.event, 'id'),
      fields,
      options
    )

  openAssessorRequest = () =>
    this.props.onOpen(
      `${MODALS.ASSESSOR_REQUEST_PE}_${get(this.props.event, 'id')}`
    )

  openJourneyOverview = (modalData = null) =>
    this.props
      .onGetAJDetail(get(this.props.event, 'id'))
      .then(() =>
        this.props.onOpen(
          `${MODALS.OVERVIEW_PE}_${get(this.props.event, 'id')}`,
          null,
          modalData
        )
      )

  render() {
    const { event, approvalStatus, aJValues, route, params } = this.props

    const awardId = get(params, 'awardId')

    const aJProgress = getAJProgressArray(get(aJValues, 'data.ajProgress'))

    const completedCount = aJProgress.filter(item => item).length.toString()

    const activityRoute = `${config.publicPath}/dashboard/awards/${params.awardId}/adventurous-journey/${params.categoryId}/${params.id}`

    const journeyType = get(event, 'ajEvent.ajEventCategory.translationText')

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(event, 'ajEvent')) || get(this.props, `configuration.values.${CONFIGURATION_KEYS.isAssessorManagementEnabled.id}.booleanValue`)

    const isPrepAndTrain =
      params.categoryId === AJ_EVENT_CATEGORIES.trainingAndPrep.url

    const hasSupervisor =
      get(event, 'ajEvent.ajEventCategory.value') ===
      AJ_EVENT_CATEGORIES.practice.id

    const supervisingRole = hasSupervisor
      ? get(event, 'ajEvent.supervisorEmail')
      : get(event, 'ajEvent.assessorEmail')

    const isAssessorSetup = get(event, 'ajEvent.assessorEmail')

    return (
      <Grid.RightOuter>
        <AJSubHeader
          activityRoute={activityRoute}
          aJProgress={aJProgress}
          isPrepAndTrain={isPrepAndTrain}
          title={
            isPrepAndTrain ? (
              <FormattedMessage
                id="moduleTitle.preparation_and_training"
                defaultMessage="Preparation and Training"
              />
            ) : (
              <FormattedMessage
                id="moduleTitle.event_journey"
                defaultMessage="{event} Journey"
                values={{ event: journeyType }}
              />
            )
          }
          subtitle={
            <FormattedMessage
              id="moduleTitle.completed_progress"
              defaultMessage={`Completed ${completedCount} / 3`}
              values={{
                finished: completedCount,
                total: '3'
              }}
            />
          }
        />

        {route && renderRoutes(route.routes, {
          ...this.props,
          colorClass,
          journeyType,
          isPrepAndTrain,
          onClickReport: this.handleClickReport,
          onAssessorRequest: this.openAssessorRequest,
          onLeaderRequest: this.openLeaderRequest
        })}

        <JourneyOverviewModal
          modalId={`${MODALS.OVERVIEW_PE}_${get(event, 'id')}`}
          colorClass={colorClass}
          aJDetail={event}
          awardId={awardId}
          ajPeId={Number(get(event, 'id'))}
          category={get(event, 'ajEvent.ajEventCategory.translationText')}
        />

        <CompleteParticipantEventJourneyModal
          modalId={`${MODALS.COMPLETE_PE}_${get(event, 'id')}`}
          colorClass={colorClass}
          id={get(event, 'id')}
          initialValues={{ observations: get(event, 'observations') }}
          awardId={awardId}
          submitDisabled={false}
          onAfterSubmit={this.openAssessorRequest}
        />

        <AssessorAjEventApprovalModal
          modalId={`${MODALS.ASSESSOR_REQUEST_PE}_${get(event, 'id')}`}
          onOpenAlreadyAssessed={this.handleOpenAlreadyAssessed}
          colorClass={colorClass}
          onSubmit={this.handleAssessorRequest}
          loading={get(approvalStatus, 'loading')}
          noSupervisor={!supervisingRole}
          hasSupervisor={hasSupervisor}
          isAssessorSetup={isAssessorSetup}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />

        <AssessorMissingModal
          modalId={`${MODALS.ASSESSOR_MISSING_INFO}_${get(event, 'id')}`}
          hasSupervisor={hasSupervisor}
          onClose={this.props.onClose}
          openJourneyOverview={this.openJourneyOverview}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />

        <LeaderApprovalModal
          modalId={`${MODALS.LEADER_REQUEST_PE}_${get(event, 'id')}`}
          colorClass={colorClass}
          onSubmit={this.handleLeaderRequest}
          loading={get(approvalStatus, 'loading')}
        />

        <AlreadyAssessedModal
          modalId={`${MODALS.ALREADY_ASSESSED_PE}_${get(event, 'id')}`}
          onSubmit={this.handleSendAlreadyAssessed}
          colorClass={colorClass}
          loading={get(approvalStatus, 'loading')}
          isAJ
        />
      </Grid.RightOuter>
    )
  }
}

export default AdventurousJourney
